import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/projects/michelin-hp/node_modules/@babel/runtime/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function brands(_x) {
  return _brands.apply(this, arguments);
}

function _brands() {
  _brands = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        response,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: '/brand-cars?sort=name&limit=100',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context.sent;
            ctx.commit('brands', response.data.items);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _brands.apply(this, arguments);
}

export function get(_x2) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx) {
    var queryParams,
        response,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axiosInstance({
              url: '/brand-cars',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context2.sent;
            ctx.commit('item', response.data.items[0]);
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", _context2.t0);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _get.apply(this, arguments);
}

export function models(_x3) {
  return _models.apply(this, arguments);
}

function _models() {
  _models = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ctx) {
    var queryParams,
        response,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.prev = 1;
            _context3.next = 4;
            return axiosInstance({
              url: parseUrl('models', queryParams),
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context3.sent;
            ctx.commit('models', response.data.items);
            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", _context3.t0);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));
  return _models.apply(this, arguments);
}

export function years(_x4) {
  return _years.apply(this, arguments);
}

function _years() {
  _years = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(ctx) {
    var queryParams,
        response,
        _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            queryParams = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            _context4.prev = 1;
            _context4.next = 4;
            return axiosInstance({
              url: parseUrl('years', queryParams),
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context4.sent;
            ctx.commit('years', response.data.items);
            _context4.next = 11;
            break;

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", _context4.t0);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 8]]);
  }));
  return _years.apply(this, arguments);
}

export function version(_x5) {
  return _version.apply(this, arguments);
}

function _version() {
  _version = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(ctx) {
    var queryParams,
        response,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            _context5.prev = 1;
            _context5.next = 4;
            return axiosInstance({
              url: parseUrl('versions', queryParams),
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context5.sent;
            ctx.commit('version', response.data.items);
            _context5.next = 11;
            break;

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", _context5.t0);

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 8]]);
  }));
  return _version.apply(this, arguments);
}

function parseUrl(state, params) {
  if (state && params.id) {
    return '/' + state + '/' + params.id;
  }

  return '/' + state;
}